import { configureStore } from '@reduxjs/toolkit';
import persistState from 'redux-localstorage';
import appReducer from '../actions';

export const store = configureStore({
  reducer: appReducer,
  middleware: (getDefaultMiddlewares) =>
    getDefaultMiddlewares({
      immutableCheck: false,
      serializableCheck: false,
    }),
  enhancers: (getDefaultEnhancers) =>
    getDefaultEnhancers().concat(
      persistState(['regions', 'timezones', 'countries']),
    ),
});
